import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function RelatedCard({ item }) {
  const to = `/blog/${item?.slug}`;
  const when = item?.createdAt || item?.date;

  return (
    <div className="custom-relatedblog-card">
      {/* LEFT IMAGE (poori image, no crop) */}
      <Link to={to} className="custom-relatedblog-img">
        <span
          className="custom-relatedblog-img-bg"
          style={{ backgroundImage: `url("${item?.image}")` }}
          aria-hidden="true"
        />
        <img src={item?.image} alt={item?.title} loading="lazy" />
      </Link>

      {/* RIGHT CONTENT */}
      <div className="custom-relatedblog-content">
        {when && <span className="custom-relatedblog-meta">{getDateAgo(when)}</span>}

        <Link to={to} className="custom-relatedblog-title">
          {item?.title}
        </Link>

        <Link to={to} className="custom-relatedblog-read">
          Read more →
        </Link>
      </div>
    </div>
  );
}

export default RelatedCard;
